// extracted by mini-css-extract-plugin
export default {"logo":"PrivacyPoliciesPage_logo__FOmdv"};